import '@everlywell/leaves/lib/style.css';

// Import all polyfills from main entry point
require('./src/polyfills');

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

import './src/styles/global.tsx';
